export default "__VITE_ASSET__DjzmPXAr__"